import SCORM from "../scorm/ScormWrapper";
import _ from "lodash";
import tree from "../../state";
import PlayerPaths from "../../constants/paths/playerPaths";
import { getResponseFromMultichoiceItem, restoreItemMultichoiceResponse, getResponseFromItem } from "../peristenceUtils";
import * as actions from "../../actions/actions";
import * as playerActions from "../../actions/playerActions";

export default class PersistenceManagerScorm2004 {

	constructor(config) {
		this.config = config;
		this.interactionCount = 0;
		this.interactionIds = {};
		this.initialResponses = {};
		this.initialSuspendData = {};

		//These don't seem to work in scorm cloud
		window.addEventListener("unload", this.unloadHandler);
		window.addEventListener("beforeunload", this.unloadHandler);
	}

	//get all responses and set interaction count
	async init(params) {
		let activities = params.activities;

		SCORM.init();
		this.interactionCount = SCORM.get("cmi.interactions._count");

		for (let i = 0; i < this.interactionCount; i++) {

			let id = SCORM.get("cmi.interactions." + i + ".id");
			let response = SCORM.get("cmi.interactions." + i + ".learner_response");

			if (!this.initialResponses[id]) {
				this.interactionIds[id] = this.initialResponses[id] = {};
			}

			this.initialResponses[id] = {
				id,
				response,
			}

			//track interaction IDs for lookup later
			this.interactionIds[id] = {
				id,
				index: i
			}
		}

		let suspendData = SCORM.get("cmi.suspend_data");
		if (!_.isUndefined(suspendData) && suspendData !== "") {
			this.initialSuspendData = JSON.parse(suspendData);
		}

		//console.log(JSON.stringify(this.initialResponses, null, 4));
		tree.set(PlayerPaths.ROOT_ACTIVITY_ID, activities[0].id); //eslint-disable-line
		actions.setActivities(tree, activities);
	}

	async save(params) {
		SCORM.set("cmi.suspend_data", JSON.stringify(this.buildSuspendData()));
		SCORM.save();
	}

	async saveAndExit() {

		//TODO: Determine if everything is complete then use exitAll for nav request

		this.save();

		SCORM.set('cmi.exit', 'suspend');
		SCORM.set('adl.nav.request', 'suspendAll');
		SCORM.quit();

		let activity = tree.get(PlayerPaths.ACTIVITY);
		return {
			activity
		}
	}

	async saveResponse(item) {

		let activity = tree.get(PlayerPaths.ACTIVITY);
		let id = "activity_" + activity.id + "_item_" + item.guid;

		//for now set value based on data type
		let response = getResponseFromItem(item);

		if (!_.isUndefined(response.value)) {
			let idx = this.findInteractionIndex(id);

			SCORM.set("cmi.interactions." + idx + ".id", id);
			SCORM.set("cmi.interactions." + idx + ".type", response.type);
			SCORM.set("cmi.interactions." + idx + ".learner_response", response.value);
		}
	}

	async setCompletionState(completionState) {
		SCORM.set("cmi.completion_status", completionState);
	}

	async trackHistory(historyItem) {
	}

	restoreActivityResponsesAndState(activity) {

		//TODO: Handle activity array

		//console.log("RESTORING DATA FOR ACTIVITY " + activity.id);

		//using id for now since it stays consistent
		let suspendData = this.initialSuspendData[activity.id];

		//restore activity values from initial lms load
		if (activity.children && suspendData) {

			if (suspendData.hasOwnProperty("selected")) {
				activity.selected = suspendData.selected;
			}

			if (suspendData.hasOwnProperty("selectedListIndex")) {
				activity.selectedListIndex = suspendData.selectedListIndex;
			}

			if (suspendData.variables) {
				activity.variables = suspendData.variables;
			}

			for (let i = 0; i < activity.children.length; i++) {

				let list = activity.children[i];
				if (list.type === "list" && list.children) {

					let listState = suspendData.objects[list.guid];

					if (!_.isUndefined(listState)) {
						if (listState.hasOwnProperty("completionState")) {
							list.completionState = listState.completionState;
						}
					}

					for (let j = 0; j < list.children.length; j++) {

						let section = list.children[j];
						if (section.type === "section" && section.children) {

							let sectionState = suspendData.objects[section.guid];

							if (!_.isUndefined(sectionState)) {
								if (sectionState.hasOwnProperty("completionState")) {
									section.completionState = sectionState.completionState;
								}
							}

							for (let k = 0; k < section.children.length; k++) {
								let item = section.children[k];
								let itemState = suspendData.objects[item.guid];

								if (!_.isUndefined(itemState)) {

									if (itemState.hasOwnProperty("completionState")) {
										item.completionState = itemState.completionState;
									}

									if (itemState.hasOwnProperty("checked")) {
										item.checked = itemState.checked;
									}

									if (itemState.hasOwnProperty("enabled")) {
										item.enabled = itemState.enabled;
									}

									if (itemState.hasOwnProperty("notes")) {
										item.notes = itemState.notes;
									}
								}
								this.restoreItemResponse(activity, item);
							}
						}
					}
				}
			}
		}
		return activity;
	}

	restoreItemResponse(activity, item) {

		let type = item.type.toLowerCase();
		let activityId = activity.id;

		let initialItemResponseObj = this.initialResponses["activity_" + activityId + "_item_" + item.guid]

		//console.log("initial response obj " + JSON.stringify(initialItemResponseObj, null, 4));

		if (initialItemResponseObj) {
			let response = initialItemResponseObj.response;

			switch (type) {
				case "item":
					let itemValue = (response === "true") ? true : false;
					item.value = itemValue;
					break;
				case "itemtextinput":
				case "itemtextinputmultiline":
				case "itempicker":
				case "itemyesno":
				case "itemtime":
				case "itemdate":
				case "itemdatetime":
				case "itemchoicesingle":
					item.value = response;
					break;
				case "itembarcodescanner":
					_.set(item, "barcode.data", response);
					break;
				case "itemaddress": //object
				case "itemlocation": //object
				case "itemimagepicker": //value, valueUrls
					item.value = JSON.parse(response);
					break;
				case "itemchoicemulti": //array
					let multiValue = restoreItemMultichoiceResponse(item, response.split('[,]'));
					item.value = multiValue;
					break;
				default:
					break;
			}
		}
	}

	//return response type and value
	getResponseFromItem(item) {

		let type = item.type.toLowerCase();
		let response;

		//TODO: need to determine what values to store as part of learner response
		switch (type) {
			case "item":
				response = {
					type: "true-false",
					value: (item.value === true) ? "true" : "false"
				}
				break;
			case "itemtextinput":
			case "itemtextinputmultiline":
			case "itemtime":
			case "itemdate":
			case "itemdatetime":
				response = {
					type: "fill-in",
					value: item.value
				}
				break;
			case "itembarcodescanner":
				response = {
					type: "fill-in",
					value: _.get(item, "barcode.data")
				}
				break;
			case "itempicker":
			case "itemyesno":
			case "itemchoicesingle":
				response = {
					type: "choice",
					value: item.value
				}
				break;
			case "itemaddress": //object
			case "itemlocation": //object
			case "itemimagepicker": //value, valueUrls
				response = {
					type: "other",
					value: JSON.stringify(item.value)
				}
				break;
			case "itemchoicemulti": //array
				response = {
					type: "choice",
					value: getResponseFromMultichoiceItem(item)
				};
				break;

			default:
				response = {
					type: "other",
					value: JSON.stringify(item.value)
				}
				break;
		}
		return response;
	}




	findInteractionIndex(id) {
		let idx;
		if (this.interactionIds[id]) {
			idx = this.interactionIds[id].index;
		} else {
			idx = this.getNextInteractionIndex(id);
		}
		return idx;
	}

	getNextInteractionIndex(id) {
		this.interactionCount++;
		this.interactionIds[id] = {
			id,
			index: this.interactionCount - 1
		}
		return this.interactionCount - 1;
	}

	unloadHandler() {
		this.saveAndExit();
	}

	buildSuspendData() {

		let suspendData = {};

		//need to loop over all activities		
		let activities = tree.get(PlayerPaths.ACTIVITIES);

		let currentActivity = tree.get(PlayerPaths.ACTIVITY);

		suspendData[currentActivity.id] = this.buildSuspendDataForActivity(currentActivity);

		_.each(activities, (activity) => {
			if (activity.id !== currentActivity.id) {
				suspendData[activity.id] = this.buildSuspendDataForActivity(activity);
			}
		});

		return suspendData;
	}

	buildSuspendDataForActivity(activity) {

		let activitySuspendData = {
			objects: {},
			selected: activity.selected,
			selectedListIndex: activity.selectedListIndex,
			variables: activity.variables
		}

		if (activity.children) {
			for (let i = 0; i < activity.children.length; i++) {

				let list = activity.children[i];
				if (list.type === "list" && list.children) {

					activitySuspendData.objects[list.guid] = {
						type: "list",
						completionState: list.completionState
					}

					for (let j = 0; j < list.children.length; j++) {

						let section = list.children[j];
						if (section.type === "section" && section.children) {

							activitySuspendData.objects[section.guid] = {
								type: "section",
								completionState: section.completionState
							}

							for (let k = 0; k < section.children.length; k++) {
								let item = section.children[k];
								activitySuspendData.objects[item.guid] = {
									type: "item",
									completionState: item.completionState,
									checked: item.checked,
									enabled: item.enabled,
									notes: item.notes
								}
							}
						}
					}
				}
			}
		}

		return activitySuspendData;
	}

	async loadActivity(activityId, initialItemId) {
		return playerActions.loadPublishedActivity(activityId, initialItemId);
	}

	async uploadMediaFile(fileData, fileName, targetType, identityId) {
		return Promise.resolve({ url: "" });
	}
}